import AV from 'leancloud-storage'

var APP_ID = 'xB0AuVO2BYNjnQDdnQ7580VW-gzGzoHsz';
var APP_KEY = 'qGkGLcrUEEBMdKMFAfIMPKer';
AV.init({
    appId: APP_ID,
    appKey: APP_KEY
});

export default AV


// WEBPACK FOOTER //
// ./src/lib/leancloud.js